import React, { useState } from "react";
import {
  Modal,
  Form,
  Card,
  Typography,
  Tag,
  notification,
  InputNumber,
} from "antd";
import Close from "../../assets/icons/close.svg";
import Button from "./button";
import colors from "../../share/constants/constants";
import { updateCustomer } from "../../api/customer";

const EarnedPointsModal = ({ onCancel, data, onOk }) => {
  const [form] = Form.useForm();
  const [inProgress, setInProgress] = useState(false);

  const onFinish = async (value) => {
    setInProgress(true);
    const payload = {
      earnedPoints: value.newEarned?.toString() || data?.earnedPoints,
    };
    const res = await updateCustomer(data?._id, payload);
    if (res) {
      notification.success({
        message: "Update Successful",
        description: "Earned Points updated successfully",
      });
      onOk(payload);
      setInProgress(false);
      onCancel();
    }
  };

  return (
    <div>
      <Modal
        open={true}
        footer={null}
        closeIcon={null}
        width="436px"
        onCancel={onCancel}
      >
        <Card>
          <div className="flex">
            <h2 className="flex-1">Manage Earned Points</h2>
            <img
              src={Close}
              alt="Cross Icon"
              className="w-3.2 hover:cursor-pointer"
              onClick={onCancel}
            />
          </div>
          <Form form={form} onFinish={onFinish}>
            <div className="fex flex-col justify-center">
              <Form.Item name="name">
                <div>
                  <Typography.Title level={5}>
                    Current Earned Points
                  </Typography.Title>
                  <Tag color="success">{data?.earnedPoints} Points</Tag>
                </div>
              </Form.Item>
              <Form.Item
                name="newEarned"
                rules={[
                  { required: data?._id ? false : true, message: "Required" },
                  {
                    pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
                    message: "Please enter a positive number",
                  },
                ]}
              >
                <div>
                  <Typography.Title level={5}>
                    Updated Earned Points
                  </Typography.Title>
                  <InputNumber
                    type="number"
                    controls={false}
                    className="flex items-center w-full h-5.4"
                    placeholder={`Updated Earned Points`}
                    defaultValue={`${data?.earnedPoints}`}
                  />
                </div>
              </Form.Item>
            </div>
            <Form.Item>
              <Button
                title={"Update"}
                color={colors.primaryPurple}
                className="flex items-center w-full"
                htmlType="submit"
                onOk={onCancel}
                // disabled={!form.isFieldsTouched(['name', 'cost'])}
                loading={inProgress}
              />
            </Form.Item>
          </Form>
        </Card>
      </Modal>
    </div>
  );
};
export default EarnedPointsModal;
